import { axios } from "../constants/axiosConfig";
import { message } from "antd";
import { normalizeCnpj } from "../helpers/functions";

const icmsModule = JSON.parse(sessionStorage.getItem("icmsModule"));
const BASE_URL = icmsModule
  ? process.env.REACT_APP_APICLOUD_URL_ICMS
  : process.env.REACT_APP_APICLOUD_URL;

// Buscar empresa pelo Id
export function getCompany() {
  const id = JSON.parse(sessionStorage.getItem("eRecuperadorCompany")).Id;
  return async (dispatch) => {
    dispatch({ type: "GET_COMPANY_REQUEST" });
    await axios
      .get(`empresa/${id}`)
      .then((response) => {
        dispatch({
          type: "GET_COMPANY_SUCCESS",
          payload: response.data,
        });
      })
      .catch(() => {
        message.error("Não foi possível obter os dados da empresa");
      });
  };
}

// Buscar empresa pelo Id
export function getCompanyRequest() {
  const id = JSON.parse(sessionStorage.getItem("eRecuperadorCompany")).Id;
  return axios.get(`empresa/${id}`);
}

// Buscar todas as empresas
export function getCompanies() {
  return async (dispatch) => {
    await axios
      .get("empresa")
      .then((response) => {
        dispatch({
          type: "GET_COMPANIES_SUCCESS",
          payload: response.data,
        });
      })
      .catch(() => {
        message.error("Não foi possível carregar a lista de empresas");
      });
    dispatch({
      type: "COMPANIES_CLEAN",
    });
  };
}

// Cadastrar nova empresa
export function setCompany(data) {
  data.Cnpj = normalizeCnpj(data.Cnpj);
  data.RazaoSocial = data.RazaoSocial.trim();
  return async (dispatch) => {
    dispatch({ type: "SET_COMPANY_REQUEST" });
    await axios
      .post("empresa", data)
      .then((response) => {
        dispatch({
          type: "SET_COMPANY_SUCCESS",
          payload: response.data,
        });
        if (response.data?.StatusCode === 200) {
          message.success("Empresa cadastrada com sucesso");
        }
      })
      .catch((error) => {
        dispatch({ type: "SET_COMPANY_FAILURE" });
        if (error && error.response && error.response.status !== 403) {
          if (error.response.data) {
            if (error.response.data.Retorno) {
              dispatch({
                type: "SET_MESSAGE_MODAL_FAILURE",
                payload: error.response.data,
              });
            } else {
              message.error(error.response.data.Mensagem);
            }
          } else {
            message.error("Não foi possível cadastrar a empresa");
          }
        }
      });
    dispatch({
      type: "COMPANIES_CLEAN",
    });
  };
}

export function downloadPlanMoviment() {
  const cnpj = JSON.parse(sessionStorage.getItem("eRecuperadorCompany")).Cnpj;
  return (dispatch) => {
    dispatch({ type: "DOWNLOAD_PLAN_REQUEST" });
    fetch(`${BASE_URL}/movimentacao/modelo/planilha/${cnpj}`, {
      method: "GET",
      headers: new Headers({
        Authorization: `Bearer ${sessionStorage.getItem("eRecuperadorJwt")}`,
      }),
    })
      .then((response) => {
        if (response.status === 200) {
          const fileName = `modelo-movimentacao-${cnpj}.xlsx`;

          response.blob().then((blob) => {
            const url = window.URL.createObjectURL(blob);
            const downloadLink = document.createElement("a");
            downloadLink.href = url;
            downloadLink.download = fileName;
            downloadLink.click();
          });

          dispatch({
            type: "DOWNLOAD_PLAN_SUCCESS",
          });
        }

        if (response.status === 400) {
          dispatch({
            type: "DOWNLOAD_PLAN_FAILURE",
          });
          message.error("Não foi possível gerar o relatório");
        }
      })
      .catch(() => {
        message.error("Não foi possível gerar o relatório");
        dispatch({
          type: "DOWNLOAD_PLAN_FAILURE",
        });
      });
  };
}

// Editar empresa
export function putCompany(data) {
  data.RazaoSocial = data.RazaoSocial.trim();

  return async (dispatch) => {
    dispatch({ type: "PUT_COMPANY_REQUEST" });
    await axios
      .put(`empresa/${data.Id}`, data)
      .then((response) => {
        dispatch({
          type: "PUT_COMPANY_SUCCESS",
          payload: response.data,
        });
        message.success("Empresa editada com sucesso");
      })
      .catch((error) => {
        dispatch({ type: "PUT_COMPANY_FAILURE" });
        if (error && error.response && error.response.status !== 403) {
          if (error.response.data) {
            message.error(error.response.data.Mensagem);
          } else {
            message.error("Não foi possível editar a empresa");
          }
        }
      });
    dispatch({
      type: "COMPANIES_CLEAN",
    });
  };
}

// Editar empresa
export function putCompanyRequest(data) {
  data.RazaoSocial = data.RazaoSocial.trim();
  return axios.put(`empresa/${data.Id}`, data);
}

export function excluirEmpresa(id, callback) {
  return (dispatch) => {
    axios
      .delete("empresa/" + id)
      .then((response) => {
        const result = response.status === 200;

        if (result) {
          message.success("Empresa excluída com sucesso!");
        } else {
          message.error("Ocorreu um erro ao excluir a empresa");
        }

        callback(result);
      })
      .catch((err) => {
        callback(false);
      });
  };
}

// Limpar mensagem de validação do modal
export function clearMessageModal() {
  return async (dispatch) => {
    dispatch({ type: "MESSAGE_MODAL_CLEAN" });
  };
}
